// @flow
import { hpfetch } from '../util';
import type { invoiceType } from '../../types';
import type {
  djangoModelApiResponse,
  wrappedApiResponseType,
} from '../apiTypes';

export const getSingle = (
  id: number,
): Promise<wrappedApiResponseType<invoiceType>> => hpfetch(`invoices/${id}/`);

export const getMany = (
  limit: number = 250,
  offset: number = 0,
): djangoModelApiResponse<invoiceType> =>
  hpfetch(`invoices/?limit=${limit}&offset=${offset}`);
